export const decisioningStudioAgentsAppGroupIdDsaIdAudiences =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/audiences";
